"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchWebmaster = fetchWebmaster;
exports.getRecipientsCountByFilters = getRecipientsCountByFilters;
exports.loadFilters = loadFilters;
exports.loadRecipientsCount = loadRecipientsCount;
exports.loadSegmentGroups = loadSegmentGroups;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = require("./utils");

var _Filters = require("@insided/deprecated-control/UserOverview/Filters");

var _axios = _interopRequireDefault(require("axios"));

var qs = _interopRequireWildcard(require("qs"));

var _utils2 = require("@insided/control/modules/Analytics/UserSegments/utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DEFAULT_RECIPIENTS_REQUEST_PARAMS = {
  opt_in: 1,
  page: 1,
  size: 1
};

function getRecipientsCountByFilters(_x, _x2, _x3) {
  return _getRecipientsCountByFilters.apply(this, arguments);
}

function _getRecipientsCountByFilters() {
  _getRecipientsCountByFilters = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(recipientsFilters, rolesMap, allGroups) {
    var _response$data;

    var params, response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (recipientsFilters) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", 0);

          case 2:
            params = {};

            if (recipientsFilters.customRoles && rolesMap !== null && rolesMap !== void 0 && rolesMap.customRoles) {
              params.custom_roles = {
                in: (0, _utils.getFilterIdList)(recipientsFilters.customRoles, rolesMap.customRoles)
              };
            }

            if (recipientsFilters.groups && allGroups) {
              params.groups = {
                in: (0, _utils.getFilterIdList)(recipientsFilters.groups, allGroups)
              };
            }

            if (recipientsFilters.mainRoles && rolesMap !== null && rolesMap !== void 0 && rolesMap.mainRoles) {
              params.role = {
                in: (0, _utils.getFilterIdList)(recipientsFilters.mainRoles, rolesMap.mainRoles)
              };
            }

            if (recipientsFilters.joinDate) {
              params.join_date = (0, _Filters.getDateParameters)('')(recipientsFilters.joinDate).value;
            }

            if (recipientsFilters.lastActivity) {
              params.last_activity = (0, _Filters.getDateParameters)('')(recipientsFilters.lastActivity).value;
            }

            _context.next = 10;
            return loadRecipientsCount(params);

          case 10:
            response = _context.sent;
            return _context.abrupt("return", (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.totalItems);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getRecipientsCountByFilters.apply(this, arguments);
}

function loadRecipientsCount(_x4) {
  return _loadRecipientsCount.apply(this, arguments);
}

function _loadRecipientsCount() {
  _loadRecipientsCount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(params) {
    var requestParams, defaultFromDateString, _dateFilterValueGener, condition, data, daysLeft, _daysLeft, _daysLeft2, daysLeftStartRange, daysLeftEndRange, response;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            requestParams = _objectSpread(_objectSpread({}, DEFAULT_RECIPIENTS_REQUEST_PARAMS), params);
            defaultFromDateString = (0, _utils.getDateByNumberOfDaysAgo)();

            if (requestParams.last_activity) {
              _dateFilterValueGener = (0, _utils2.dateFilterValueGenerator)(requestParams.last_activity), condition = _dateFilterValueGener.condition, data = _dateFilterValueGener.data; // less than X days ago, X >= 365   =>   { from: 365 }

              if (condition === 'lt' && +data >= _utils.DEFAULT_LAST_ACTIVITY_DAYS_AGO) {
                requestParams.last_activity = {
                  from: defaultFromDateString
                };
              } // more than X days ago, X < 365   =>   { from: 365, to: X }
              // more than X days ago, X >= 365   =>   { from: 365 }


              if (condition === 'gt') {
                if (+data < _utils.DEFAULT_LAST_ACTIVITY_DAYS_AGO) {
                  requestParams.last_activity = {
                    from: defaultFromDateString,
                    to: (0, _utils.getDateByNumberOfDaysAgo)(+data)
                  };
                } else if (+data >= _utils.DEFAULT_LAST_ACTIVITY_DAYS_AGO) {
                  requestParams.last_activity = {
                    from: defaultFromDateString
                  };
                }
              } // before X date, X < 365 days ago   =>   { from: 365, to: X }
              // before X date, X >= 365 days ago   =>   { from: 365 }


              if (condition === 'to' && typeof data === 'string') {
                daysLeft = (0, _utils.getDaysLeftPastDate)(data);

                if (daysLeft < _utils.DEFAULT_LAST_ACTIVITY_DAYS_AGO) {
                  requestParams.last_activity = {
                    from: defaultFromDateString,
                    to: data
                  };
                } else if (daysLeft >= _utils.DEFAULT_LAST_ACTIVITY_DAYS_AGO) {
                  requestParams.last_activity = {
                    from: defaultFromDateString
                  };
                }
              } // on X date, X >= 365 days ago   =>   { from: 365 }


              if (condition === 'eq' && typeof data === 'string') {
                _daysLeft = (0, _utils.getDaysLeftPastDate)(data);

                if (_daysLeft >= _utils.DEFAULT_LAST_ACTIVITY_DAYS_AGO) {
                  requestParams.last_activity = {
                    from: defaultFromDateString
                  };
                }
              } // after X date, X >= 365 days ago   =>   { from: 365 }
              // after X date, X < 365 days ago   =>   { from: X } - nothing to change


              if (condition === 'from' && typeof data === 'string') {
                _daysLeft2 = (0, _utils.getDaysLeftPastDate)(data);

                if (_daysLeft2 >= _utils.DEFAULT_LAST_ACTIVITY_DAYS_AGO) {
                  requestParams.last_activity = {
                    from: defaultFromDateString
                  };
                }
              } // { from: X, to: Y }, Y >= 365 days ago   =>   { from: 365 }
              // { from: X, to: Y }, X >= 365 days ago   =>   { from: 365, to: Y }


              if (condition === 'range' && typeof data !== 'string' && data.from && data.to) {
                daysLeftStartRange = (0, _utils.getDaysLeftPastDate)(data.from);
                daysLeftEndRange = (0, _utils.getDaysLeftPastDate)(data.to);

                if (daysLeftEndRange >= _utils.DEFAULT_LAST_ACTIVITY_DAYS_AGO) {
                  requestParams.last_activity = {
                    from: defaultFromDateString
                  };
                } else if (daysLeftStartRange >= _utils.DEFAULT_LAST_ACTIVITY_DAYS_AGO) {
                  requestParams.last_activity = {
                    from: defaultFromDateString,
                    to: data.to
                  };
                }
              }
            } else {
              requestParams.last_activity = {
                from: defaultFromDateString
              };
            }

            _context2.next = 5;
            return _axios.default.get('/users/overview/get', {
              params: requestParams,
              paramsSerializer: function paramsSerializer(requestParams) {
                return qs.stringify(requestParams, {
                  arrayFormat: 'brackets'
                });
              }
            });

          case 5:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadRecipientsCount.apply(this, arguments);
}

function fetchRoles() {
  return _fetchRoles.apply(this, arguments);
}

function _fetchRoles() {
  _fetchRoles = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var res;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.get('/role/fetchRolesForFilter');

          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchRoles.apply(this, arguments);
}

function loadFilters(_x5) {
  return _loadFilters.apply(this, arguments);
}

function _loadFilters() {
  _loadFilters = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(groupsMap) {
    var rolesMap;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetchRoles();

          case 2:
            rolesMap = _context4.sent;
            rolesMap.customRoles = rolesMap.customRoles ? (0, _utils.normalizeUserRoles)(rolesMap.customRoles) : [];
            rolesMap.mainRoles = rolesMap.mainRoles ? (0, _utils.normalizeUserRoles)(rolesMap.mainRoles) : [];
            return _context4.abrupt("return", {
              rolesMap: rolesMap,
              filters: (0, _utils.getFilters)(rolesMap, groupsMap)
            });

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _loadFilters.apply(this, arguments);
}

function fetchWebmaster() {
  return _fetchWebmaster.apply(this, arguments);
}

function _fetchWebmaster() {
  _fetchWebmaster = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
    var res;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.get('/settings/emailManagement/getSecondaryWebmaster');

          case 2:
            res = _context5.sent;
            return _context5.abrupt("return", res.data);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchWebmaster.apply(this, arguments);
}

function loadSegmentGroups() {
  return _loadSegmentGroups.apply(this, arguments);
}

function _loadSegmentGroups() {
  _loadSegmentGroups = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _axios.default.get('/users/segment-groups').then(function (res) {
              return res.data;
            });

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _loadSegmentGroups.apply(this, arguments);
}